import React, {PureComponent} from "react"
import authentication from "@irati/auth"
import UsersForBusiness, {userList, UsersForBusinessVariables} from "@irati/identity/apollo/query/UsersForBusiness"
import {Team} from "@irati/types"
import FormattedMessage from "@irati/utils/lang"
import AdminHeader, {Props as AdminHeaderProps} from "./AdminHeader"

const COUNT_VARIABLES = (teamId: string): UsersForBusinessVariables => ({
  includeBusiness: false,
  limit: 1,
  offset: 0,
  enabled: true,
  businessId: authentication.userTenant().uuid,
  teamId
})

interface Props extends Omit<AdminHeaderProps, "title" | "count"> {
  team: Team
}

export default class TeamAdminHeader extends PureComponent<Props> {
  /** @description: Fallback function until `<UsersForBusiness />` Query component mounts */
  refetch = () => {}

  render() {
    const {team} = this.props
    if (!team) {
      return null
    }

    return (
      <UsersForBusiness variables={COUNT_VARIABLES(team.uuid)}>
        {(apollo) => {
          this.refetch = apollo.refetch
          const {total} = userList(apollo)
          return (
            <AdminHeader
              title={team.public_name}
              errorCount={team.managers?.total === 0 && <FormattedMessage id="admin.containers.teamUserList.noManagersCount" />}
              infoCount={
                total > 0 ? <FormattedMessage id="admin.containers.teamUserList.nameCountAndButton.count" values={{total}} /> : undefined
              }
            />
          )
        }}
      </UsersForBusiness>
    )
  }
}
